require("select2/dist/css/select2.min.css");
require("select2");

// Proxies to the upstream API server-side (core/vaad_form/vaad_form.php:
// iomv_vaad_form_rest_submit) — same CORS/API-key reasoning as
// LOCATIONS_REFRESH_ENDPOINT below.
const VAAD_FORM_ENDPOINT = "/wp-json/iomv-theme/v1/vaad-form";

// The upstream locations API doesn't send Access-Control-Allow-Origin, so a
// direct browser fetch() to it hits CORS — and would also leak the API key
// into the public JS bundle. This calls our own origin instead; the server
// does the real GET (core/locations/locations.php: iomv_locations_refresh).
const LOCATIONS_REFRESH_ENDPOINT = "/wp-json/iomv-theme/v1/locations/refresh";

function fetchLocations() {
    return fetch(LOCATIONS_REFRESH_ENDPOINT, {
        method: "POST",
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error("Refresh request failed with status " + response.status);
            }

            return response.json();
        });
}

(function ($) {

    // Country -> State -> City chained selects (select2.org "Chained Selects"
    // pattern): each level is a plain select2 with its options replaced
    // whenever the level above it changes. "tags: true" on all three lets a
    // visitor type a value that isn't in the locations.json dataset.
    function initLocationSelects($form) {
        const $country = $form.find(".js-country-select");
        const $state = $form.find(".js-state-select");
        const $city = $form.find(".js-city-select");
        const config = window.IOMV_VAAD_FORM || {};
        const vaadId = $form.find("[name=\"vaad_id\"]").val();

        if (!$country.length || !$state.length || !$city.length || typeof $.fn.select2 !== "function") {
            return;
        }

        if (!config.countriesEndpoint || !config.statesEndpoint || !config.citiesByStateEndpoint) {
            return;
        }

        function initSelect($select) {
            $select.select2({
                width: "100%",
                placeholder: $select.data("placeholder") || "",
                allowClear: true,
                tags: true,
            });
        }

        function fillOptions($select, items) {
            $select.empty().append(new Option("", "", false, false));

            items.forEach((item) => {
                $select.append(new Option(item.text, item.id, false, false));
            });

            $select.val(null).trigger("change");
        }

        initSelect($country);
        initSelect($state);
        initSelect($city);

        $state.prop("disabled", true);
        $city.prop("disabled", true);

        $.getJSON(config.countriesEndpoint)
            .done((data) => fillOptions($country, data.results || []));

        // State/city stay disabled until their fetch actually resolves with
        // options — enabling an empty dropdown just to open onto nothing is
        // worse than leaving it inactive.
        $country.on("change", function () {
            const country = $country.val();

            fillOptions($state, []);
            $state.prop("disabled", true);

            if (!country) {
                return;
            }

            $.getJSON(config.statesEndpoint, { country, vaad_id: vaadId })
                .done((data) => {
                    const results = data.results || [];
                    fillOptions($state, results);
                    $state.prop("disabled", results.length === 0);
                });
        });

        $state.on("change", function () {
            const country = $country.val();
            const state = $state.val();

            fillOptions($city, []);
            $city.prop("disabled", true);

            if (!country || !state) {
                return;
            }

            $.getJSON(config.citiesByStateEndpoint, { country, state, vaad_id: vaadId })
                .done((data) => {
                    const results = data.results || [];
                    fillOptions($city, results);
                    $city.prop("disabled", results.length === 0);
                });
        });
    }

    function initPhoneCodeSelect2($form) {
        const $phoneCode = $form.find(".js-phone-code-select");

        if (!$phoneCode.length || typeof $.fn.select2 !== "function") {
            return;
        }

        $phoneCode.select2({
            width: "resolve",
            minimumResultsForSearch: Infinity,
        });
    }

    function buildPayload($form, formType) {
        const payload = {
            vaad_id: ($form.find("[name=\"vaad_id\"]").val() || "").trim(),
            form_type: formType,
            full_name: $form.find("[name=\"full_name\"]").val().trim(),
            phone_code: $form.find("[name=\"phone_code\"]").val(),
            phone: $form.find("[name=\"phone\"]").val().trim(),
            email: $form.find("[name=\"email\"]").val().trim(),
            country: ($form.find("[name=\"country\"]").val() || "").trim(),
            state: ($form.find("[name=\"state\"]").val() || "").trim(),
            city: ($form.find("[name=\"city\"]").val() || "").trim(),
            question_title: $form.find("[name=\"question_title\"]").val().trim(),
            question: $form.find("[name=\"question\"]").val().trim(),
        };

        if (formType === "confirm") {
            payload.meeting_times = $form.find(".time-box").map(function () {
                const $box = $(this);

                return {
                    time: $box.data("time"),
                    answer: $box.find("input[type=\"radio\"]:checked").val() || null,
                };
            }).get();

            payload.coordinate = $form.find("[name=\"coordinate\"]:checked").val() || null;
            payload.watched_intro = $form.find("[name=\"watched_intro\"]").is(":checked");
            payload.read_information = $form.find("[name=\"read_information\"]").is(":checked");
        } else {
            payload.read_details = $form.find("[name=\"read_details\"]").is(":checked");
        }

        return payload;
    }

    function setStatus($form, message, isError) {
        $form.find(".form-status")
            .text(message)
            .toggleClass("is-error", !!isError)
            .toggleClass("is-success", !isError && !!message);
    }

    // Backstop for the phone input's HTML "pattern" attribute: Chromium
    // doesn't reliably enforce patternMismatch on type="tel" fields, so a
    // value like "abc" can pass native constraint validation unnoticed.
    function isPhoneValid(value) {
        const digits = value.replace(/\D/g, "");
        return digits.length >= 6 && digits.length <= 15 && /^[0-9+\s().-]+$/.test(value);
    }

    // Swallows the rejection (nothing to show the visitor for a background
    // refresh) rather than leaving it uncaught — a bare fetch().catch()-less
    // chain would otherwise surface as an unhandled promise rejection.
    fetchLocations().catch(() => {});

    $(".custom-vaad-form").each(function () {
        const $form = $(this);

        initLocationSelects($form);
        initPhoneCodeSelect2($form);
    });

    $(".custom-vaad-form").on("submit", function (e) {
        e.preventDefault();

        const $form = $(this);
        const formType = $form.data("form-type");
        const $submit = $form.find(".form-submit");
        const $phone = $form.find("[name=\"phone\"]");

        if (!isPhoneValid($phone.val())) {
            setStatus($form, "Please enter a valid phone number.", true);
            $phone.trigger("focus");
            return;
        }

        const payload = buildPayload($form, formType);

        $submit.prop("disabled", true);
        setStatus($form, "", false);

        fetch(VAAD_FORM_ENDPOINT, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Request failed with status " + response.status);
                }

                return response.json();
            })
            .then(() => {
                setStatus($form, "Thank you! Your submission has been received.", false);
                $form[0].reset();
            })
            .catch(() => {
                setStatus($form, "Something went wrong. Please try again later.", true);
            })
            .finally(() => {
                $submit.prop("disabled", false);
            });
    });

})(jQuery);
